import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  theme: "light",
  lang: "EN",
  showCreateCollectionModal: false,
  showEditProfileModal: false,
  showConnectWalletModal: true,
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    changeTheme: (state, action) => {
      state.theme = action.payload;
    },
    changeLang: (state, action) => {
      state.lang = action.payload;
    },
    toggleCreateCollectionModal: (state) => {
      state.showCreateCollectionModal = !state.showCreateCollectionModal;
    },
    toggleEditProfileModal: (state) => {
      state.showEditProfileModal = !state.showEditProfileModal;
    },
    toggleConnectWalletModal: (state) => {
      state.showConnectWalletModal = !state.showConnectWalletModal;
    },
  },
});

// Action creators are generated for each case reducer function
export const { changeTheme, changeLang, toggleCreateCollectionModal, toggleEditProfileModal, toggleConnectWalletModal } = appSlice.actions;

export default appSlice.reducer;
